<template>
  <div class="core-arrow-button next-step-button">
    <span class="wrapper-inner">
      <span class="cutout-backdrop" aria-hidden="true"></span>
      <IconCircleChevronDownFilled class="arrow-icon" size="32" aria-hidden="true" />
    </span>
  </div>
</template>

<script lang="ts" setup>
import { IconCircleChevronDownFilled } from '@tabler/icons-vue'
</script>

<style lang="postcss" scoped>
.core-arrow-button {
  .wrapper-inner {
    @apply relative inline-flex cursor-pointer overflow-hidden;
    @apply h-8 w-8 items-center justify-center rounded-full bg-primary-default leading-none;
    @apply transition-all duration-200 ease-out;
    box-shadow:
      0 2px 3px rgba(0, 0, 0, 0.24),
      0 6px 10px -5px rgba(0, 0, 0, 0.28);
    transform: translateY(0);

    .cutout-backdrop {
      @apply absolute left-1/2 top-1/2 h-4 w-4 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white;
    }

    .arrow-icon {
      @apply relative z-[1] block text-primary-default;
    }
  }

  &:hover .wrapper-inner {
    box-shadow:
      0 4px 5px rgba(0, 0, 0, 0.22),
      0 10px 14px -6px rgba(0, 0, 0, 0.3);
    transform: translateY(-1px);
  }

  &:active .wrapper-inner {
    box-shadow:
      0 1px 2px rgba(0, 0, 0, 0.24),
      0 3px 6px -4px rgba(0, 0, 0, 0.26);
    transform: translateY(1px);
  }

  &.next-step-button {
    @apply absolute left-1/2 -bottom-4 -ml-4;
  }
}
</style>
